import React from 'react';
import { CarCard } from '@perxis-auto/ui-kit/lib/components/CarCard';

import getCarSpecifications from '@/features/cars/helpers/getCarSpecifications';

import { CardTableProps } from './CardTable.types';

function CardTable({ data, items, isLoading = false }: CardTableProps) {
  if (isLoading) {
    return <CarCard.TableSkeleton />;
  }

  if (!data) {
    return null;
  }

  const specifications = getCarSpecifications(data, items);

  if (!specifications.length) {
    return null;
  }

  return (
    <CarCard.Table
      items={specifications.map(spec => ({
        id: spec.id,
        name: spec.label,
        value: spec.value,
      }))}
    />
  );
}

export default CardTable;
